module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!--  css in staticUCs.css  -->\n<fieldset class="phx-populations-detail">\n  <div class="phx-populations-menu-popup">\n    <label for="nom" class="required" style="width:1em"></label>\n    <span class="cmbCollab"></span>\n    <br><br>\n    <button type="button" class="buttonAppliquer" type="button">'+
((__t=(i18n.t("populationsmenu.appliquer")))==null?'':__t)+
'</button>\n  </div>\n</fieldset>\n';
}
return __p;
};
